__turbopack_context__.v({
  "container": "OurWorkSection-module-scss-module__saOKtG__container",
  "description": "OurWorkSection-module-scss-module__saOKtG__description",
  "fade-in-up": "OurWorkSection-module-scss-module__saOKtG__fade-in-up",
  "grid": "OurWorkSection-module-scss-module__saOKtG__grid",
  "projectCard": "OurWorkSection-module-scss-module__saOKtG__projectCard",
  "title": "OurWorkSection-module-scss-module__saOKtG__title",
  "visible": "OurWorkSection-module-scss-module__saOKtG__visible",
});
